import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { AuthorityService } from "../services/authority.service";

@Directive({
    selector: '[renderIfEveryAuthority]'
})
export class RenderIfEveryAuthorityDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) { }

    @Input() set renderIfEveryAuthority(authorities: string[]) {
        const hasAccess = AuthorityService.hasEveryAuthority(authorities);

        if (hasAccess) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
